import React from 'react';
import PropTypes from 'prop-types';
import {
  DataGridCustom,
  Grid,
  Input,
} from '../../components';
import {
  tipoEntidade,
} from '../../utils/listsSelect';

const SelecaoEntidade = (props) => {
  const listaFiltradaDestinatarios = () => {
    const listaOrgaosFederais = [];
    let listaParticipantes = props.destinatarios.filter((item) => {
      if ((item.inOrgaoUniao) && (((!item.inOrgaoExtinto) && item.inOrgaoCentralizador === 1) || ((!item.inOrgaoExtinto) && item.inOrgaoCentralizador === 0))) {
        listaOrgaosFederais.push(item);
      } else if ((!item.inOrgaoExtinto) &&
        ((item.tipoRegimeProprio === props.tipoEntidade && ((item.uf && props.tipoEntidade === 2) ? item.uf === props.uf : true)))) {
        return item;
      }
      return null;
    });
    if (listaOrgaosFederais.length > 0 && props.tipoEntidade === 1) {
      listaParticipantes = listaOrgaosFederais;
    }
    if (props.papelUsuarioLogado === 'analista-rgps' || props.tipoRegimeObservador === 1) {
      const index = listaParticipantes.findIndex(item => (item.value === '01000'));
      if (index !== -1) {
        listaParticipantes.splice(index, 1);
      }
    }
    return listaParticipantes;
  };

  const carregaUfDosMunicipios = () => {
    const listaUf = [];
    props.destinatarios.forEach((item) => {
      if (item.uf && !listaUf.find(itemLista => itemLista.value === item.uf)) {
        listaUf.push({
          label: item.uf,
          value: item.uf,
        });
      }
    });
    listaUf.sort((a, b) => {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });
    return listaUf;
  };

  const regimes = props.listaTiposRegimes;
  let selecaoEntidade;
  const selecaoTipoRegime = (
    <div className="row">
      <Grid cols="4 4 4 4">
        <Input
          label="Tipo de Regime"
          number
          onChange={e => props.handleChange(e, props.nomeAtributoComboboxRegime)}
          placeholder="Selecione o tipo de regime origem"
          value={props.tipoRegime}
          itemList={regimes}
          required
          custom
          disabled={props.desabilitar}
        />
      </Grid>
    </div>
  );

  if (props.tipoRegime === 2) {
    selecaoEntidade = (
      <div className="row">
        <Grid cols="4 4 4 4">
          <Input
            label="Entidade"
            onChange={e => props.handleChange(e, props.nomeAtributoComboboxTipoEntidade)}
            placeholder="Selecione a entidade"
            value={props.tipoEntidade}
            itemList={tipoEntidade}
            required
            custom
            number
            disabled={props.desabilitar}
          />
        </Grid>
        {props.tipoEntidade === 2 ? (
          <Grid cols="4 4 4 4">
            <Input
              label="UF"
              onChange={e => props.handleChange(e, props.nomeAtributoComboboxUF)}
              placeholder="Selecione a UF"
              value={props.uf}
              itemList={carregaUfDosMunicipios()}
              custom
              required
              disabled={props.desabilitar}
            />
          </Grid>
        ) : ''}
        <Grid cols="8 8 8 8">
          <Input
            label={props.labelComboboxParticipante}
            onChange={e => props.handleChange(e, props.nomeAtributoComboboxParticipante)}
            placeholder="Selecione o destinatário"
            value={props.participante}
            itemList={listaFiltradaDestinatarios()}
            required
            custom
            disabled={props.desabilitar}
          />
        </Grid>
      </div>
    );
  }

  return (
    <DataGridCustom title={props.titulo} retirarLinhaSeparadora={props.retirarLinhaSeparadora}>
      { selecaoTipoRegime }
      { selecaoEntidade }
    </DataGridCustom>
  );
};

SelecaoEntidade.propTypes = {
  destinatarios: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.number,
    tipoRegimeProprio: PropTypes.number,
  }).isRequired,
  listaTiposRegimes: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  titulo: PropTypes.string.isRequired,
  retirarLinhaSeparadora: PropTypes.bool.isRequired,
  nomeAtributoComboboxRegime: PropTypes.string.isRequired,
  nomeAtributoComboboxParticipante: PropTypes.string.isRequired,
  nomeAtributoComboboxTipoEntidade: PropTypes.string.isRequired,
  nomeAtributoComboboxUF: PropTypes.string.isRequired,
  participante: PropTypes.number.isRequired,
  papelUsuarioLogado: PropTypes.string.isRequired,
  tipoRegime: PropTypes.number.isRequired,
  tipoRegimeObservador: PropTypes.number.isRequired,
  tipoEntidade: PropTypes.number.isRequired,
  uf: PropTypes.number.isRequired,
  labelComboboxParticipante: PropTypes.string.isRequired,
  desabilitar: PropTypes.bool.isRequired,
};

export default SelecaoEntidade;



// WEBPACK FOOTER //
// ./src/pages/relatorios/SelecaoEntidade.jsx